import script from "./NoWrapText.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoWrapText.vue?vue&type=script&setup=true&lang=ts"

import "./NoWrapText.vue?vue&type=style&index=0&id=03ae545e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03ae545e"]])

export default __exports__